export default __webpack_public_path__ + "static/media/ic-code-conduct.c70c0499.svg";